import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Menu from "../Menu";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";

const UpdateSubGroup = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the SubGroup ID from the URL
  const { getUrlByOperation } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    id: id,
    groupid: "",
    name: "",
    remark: "",
    active: true,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch the existing data for the SubGroup
  useEffect(() => {
    if (id) {
      const fetchSubGroupData = async () => {
        const token = getCookie("token");
        const userid = getCookie("userid");

        if (!token || !userid) {
          console.error("Missing token or userId");
          setMessage("Authentication failed");
          return;
        }

        try {
          const SubGroupSearch = "https://api.dqr-display-tms.bonrix.in/api/SubGroupOperation/SubUser/Search";
          
          const response = await axios.post(
            SubGroupSearch,
            {
              id: parseInt(id),
              ispageload: false,
              pagesize: 1,
              currentpageno: 0,
              withoutpagination: false,
              pagedirection: "first",
            },
            {
              headers: {
                "X-Authorization": token,
                UserId: userid,
                "Content-Type": "application/json-patch+json",
                accept: "text/plain",
              },
            }
          );

          if (response.data && Array.isArray(response.data.data) && response.data.data[0]) {
            const subgroupData = response.data.data[0];
            setFormData({
              id: subgroupData.id,
              groupid: subgroupData.groupid || "",
              name: subgroupData.name || "",
              remark: subgroupData.remark || "",
              active: subgroupData.active !== undefined ? subgroupData.active : true,
            });
          } else {
            setMessage("SubGroup not found");
          }
        } catch (error) {
          console.error("Error fetching subgroup data:", error);
          setMessage("Failed to fetch subgroup data.");
        } finally {
          setLoading(false);
        }
      };

      fetchSubGroupData();
    }
  }, [id, getUrlByOperation]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "active" ? value === "Active" : value, // Convert active to boolean
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      setMessage("SubGroup name is required");
      return;
    }

    if (!formData.remark.trim()) {
      setMessage("Remark is required");
      return;
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId");
      setMessage("Authentication failed");
      return;
    }

    setLoading(true);

    // Create an object with only the fields that should be sent in the update request
    const updateData = {
      id: parseInt(formData.id),
      active: formData.active, // Ensure it's a boolean value
      remark: formData.remark,
    };

    try {
      const SubGroupUpdate = getUrlByOperation("SubGroupUpdate") ||
        "https://api.dqr-display-tms.bonrix.in/api/SubGroupOperation/Update";
      
      const response = await axios.post(
        SubGroupUpdate,
        updateData,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
            accept: "text/plain",
          },
        }
      );

      // Check if the API response indicates success or failure
      if (response.data && response.data.isresponse && response.data.responsestatus !== "FAIL") {
        setMessage("SubGroup updated successfully!");

        // Set a delay before navigating
        setTimeout(() => {
          navigate(`/subgroup/${formData.groupid}`);
        }, 1500);
      } else {
        // Display the error message from API
        setMessage(response.data?.errormsg || "Failed to update subgroup");
      }
    } catch (error) {
      console.error("Error updating subgroup:", error);
      setMessage("Failed to update subgroup.");
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return (
      <>
        <Menu />
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content">
              <div className="container-fluid text-center p-5">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Update SubGroup</h3>
                    </div>
                    <div className="card-body">
                      <form id="update-subgroup" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>SubGroup Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter subgroup name"
                                name="name"
                                required
                                readOnly
                                style={{
                                  backgroundColor: "#f0f0f0",
                                  opacity: 0.65,
                                  cursor: "not-allowed",
                                  filter: "blur(0.5px)",
                                  color: "#666"
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter remark"
                                name="remark"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active ? "Active" : "Deactive"}
                                onChange={handleChange}
                              >
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="update-subgroup-btn"
                            className="btn btn-info"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm mr-1"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Updating...
                              </>
                            ) : (
                              "Update"
                            )}
                          </button>
                          <button
                            type="button"
                            className="btn btn-default ml-2"
                            onClick={() => navigate(`/subgroup/${formData.groupid}`)}
                            disabled={loading}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "SubGroup updated successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message && message !== "SubGroup updated successfully!" ? (
        <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default UpdateSubGroup;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

